// components/Banner.js
import React from "react";
import styles from "./banners.module.css";

export const Banner = ({ image, text, children }) => {
  return (
    <div className={styles.bannerContainer}>
      <img src={image} className={styles.image} alt="Banner" />
      <div className={styles.textbanner}>
        <div className={`${styles.text}`}>{text}</div>
        {children}
      </div>
    </div>
  );
};
